import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { ProtocoloTramitacaoAtualizarRequest, ProtocoloTramitacaoConsultarRequest, ProtocoloTramitacaoResponse } from './protocolo-tramitacao.model';

@Injectable({ providedIn: 'root' })
export class ProtocoloTramitacaoService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.protocoloTramitacao;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultar(params: ProtocoloTramitacaoConsultarRequest, context?: HttpContext): Observable<ProtocoloTramitacaoResponse[]> {
        const httpParams = new HttpParams().set('num_protocolo', params.numeroProtocolo).set('ano_protocolo', params.anoProtocolo).set('uf', params.uf);
        return this.http.get<ProtocoloTramitacaoResponse[]>(`${this.PATH}/consultar`, { params: httpParams, context });
    }

    atualizar(body: ProtocoloTramitacaoAtualizarRequest, context?: HttpContext): Observable<string> {
        const payload = {
            numeroProtocolo: body.numeroProtocolo,
            anoProtocolo: body.anoProtocolo,
            textoInformativo: body.textoInformativo,
            dataTramitacao: body.dataTramitacao,
            uf_protocolo: body.ufProtocolo
        };

        return this.http.put(`${this.PATH}/atualizar`, payload, { responseType: 'text', context });
    }
}
